import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ForYouSection } from './components/ForYouSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ResultsSection } from './components/ResultsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-zinc-300 font-sans selection:bg-brand-orange selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MethodSection data-id="element-3" />
      <BenefitsSection data-id="element-4" />
      <ForYouSection data-id="element-5" />
      <HowItWorksSection data-id="element-6" />
      <ResultsSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}